<template>
    <div id="case">
        <Header></Header>
        <div class="case-img">
        </div>
    </div>
</template>

<script>
    import {onloadRefresh} from '../utils/imgRefresh'
    import Header from '../pages/header/header'
    export default {
        name: "linYun",
        components:{
            Header
        },
        mounted() {
            onloadRefresh(this,require(`../assets/linYun/邻云.jpg`))
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/css/public";
</style>
